module.exports = __webpack_public_path__ + "img/female_icon_white.2ab85168.svg";